import { IApplicationState } from '../../types/redux';
import { getFilters } from '../filters';

export const moscowCoords = { lat: 55.755814, lng: 37.617635 };
export const moscowZoom = 10;

export function getLocationCenterCoordinates(state: IApplicationState) {
  const { location } = getFilters(state);
  const coordinates = state.locations.hash[location].centerCoordinates;

  if (!coordinates?.lat || !coordinates.lng) {
    return { center: moscowCoords, zoom: moscowZoom };
  }

  const center = { lat: coordinates.lat, lng: coordinates.lng };

  if (!coordinates.scale) {
    return { center, zoom: moscowZoom };
  }

  return { center, zoom: coordinates.scale };
}
